import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/model/expandModel.ts";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createEvent, createStore } from 'effector';
export function createExpandModel() {
  var resetExpanded = createEvent({
    name: "resetExpanded",
    sid: "gegn08"
  });
  var setItemExpanded = createEvent({
    name: "setItemExpanded",
    sid: "qzt3tn"
  });
  var setMultiplyExpanded = createEvent({
    name: "setMultiplyExpanded",
    sid: "vi9xhu"
  });
  var expandAll = createEvent({
    name: "expandAll",
    sid: "-onmkvc"
  });
  var expanded$ = createStore({}, {
    name: "expanded$",
    sid: "-31htph"
  }).on(setItemExpanded, function (state, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, value));
  }).on(expandAll, function (state, keys) {
    var newState = _objectSpread({}, state);

    keys.forEach(function (key) {
      return newState[key] = true;
    });
    return newState;
  }).on(setMultiplyExpanded, function (state, _ref2) {
    var keys = _ref2.keys,
        value = _ref2.value;

    var newState = _objectSpread({}, state);

    keys.forEach(function (key) {
      return newState[key] = value;
    });
    return newState;
  }).reset(resetExpanded);
  return {
    expanded$: expanded$,
    setItemExpanded: setItemExpanded,
    resetExpanded: resetExpanded,
    expandAll: expandAll,
    setMultiplyExpanded: setMultiplyExpanded
  };
}